// 1. 地图属性
// ====================
// 设置地图障碍物占位
export const MAP__SET_MAP_MARGINS = 'MAP__SET_MAP_MARGINS';
// 设置地图障碍物下方占位
export const MAP__SET_MAP_MARGIN_BOTTOM = 'MAP__SET_MAP_MARGIN_BOTTOM';
// 设置地图实例
export const MAP__SET_MAP_INSTANCE = 'MAP__SET_MAP_INSTANCE';
// 设置地图模式
export const MAP__SET_MAP_MODE = 'MAP__SET_MAP_MODE';
// 设置地图缩放模式
export const MAP__SET_FIT_VIEW_MODE = 'MAP__SET_FIT_VIEW_MODE';

// 2. 数据源
// ====================
// 设置运营区域列表
export const MAP__SET_MAP_DATA_AREAS = 'MAP__SET_MAP_DATA_AREAS';
// 向运营区域列表添加一个区域
export const MAP__ADD_MAP_DATA_AREA = 'MAP__ADD_MAP_DATA_AREA';
// 移除某一运营区域
export const MAP__REMOVE_MAP_DATA_AREA = 'MAP__REMOVE_MAP_DATA_AREA';
// 设置运营站点列表
export const MAP__SET_MAP_DATA_STOPS = 'MAP__SET_MAP_DATA_STOPS';
// 设置用户位置
export const MAP__SET_MAP_USER_POS = 'MAP__SET_MAP_USER_POS';
// 设置用户位置数据（不止坐标）
export const MAP__SET_MAP_USER_POS2 = 'MAP__SET_MAP_USER_POS2'
// 设置上车站对象
export const MAP__SET_MAP_DATA_ON_STOP = 'MAP__SET_MAP_DATA_ON_STOP';
// 设置下车站对象
export const MAP__SET_MAP_DATA_OFF_STOP = 'MAP__SET_MAP_DATA_OFF_STOP';
// 设置区域中心点对象
export const MAP__SET_MAP_DATA_AREA_CENTER_POS = 'MAP__SET_MAP_DATA_AREA_CENTER_POS';
// 设置车辆位置
export const MAP__SET_MAP_DATA_BUS_POS = 'MAP__SET_MAP_DATA_BUS_POS';
// 设置运行中的上车站位置对象
export const MAP__SET_MAP_DATA_RUNNING_ON_STOP = 'MAP__SET_MAP_DATA_RUNNING_ON_STOP';
// 设置运行中的下车站位置对象
export const MAP__SET_MAP_DATA_RUNNING_OFF_STOP = 'MAP__SET_MAP_DATA_RUNNING_OFF_STOP';
// 设置运行中的脊线
export const MAP__SET_MAP_DATA_RUNNING_ROUTE = 'MAP__SET_MAP_DATA_RUNNING_ROUTE'
// 设置运行中的途经点
export const MAP__SET_MAP_DATA_RUNNING_NAVI_STOP = 'MAP__SET_MAP_DATA_RUNNING_NAVI_STOP';


// 3. 覆盖物
// ====================
// 设置运营区域多边形列表
export const MAP__SET_OVERLAY_AREA_POLYGONS = 'MAP__SET_OVERLAY_AREA_POLYGONS';
// 设置运营站点marker列表
export const MAP__SET_OVERLAY_STOP_MARKERS = 'MAP__SET_OVERLAY_STOP_MARKERS';
// 设置上车站marker
export const MAP__SET_OVERLAY_ON_STOP_MARKER = 'MAP__SET_OVERLAY_ON_STOP_MARKER';
// 设置下车站marker
export const MAP__SET_OVERLAY_OFF_STOP_MARKER = 'MAP__SET_OVERLAY_OFF_STOP_MARKER';
// 设置上车站label
export const MAP__SET_OVERLAY_ON_STOP_LABEL = 'MAP__SET_OVERLAY_ON_STOP_LABEL';
// 设置下车站label
export const MAP__SET_OVERLAY_OFF_STOP_LABEL = 'MAP__SET_OVERLAY_OFF_STOP_LABEL';
// 设置用户位置marker
export const MAP__SET_OVERLAY_USER_POS_MARKER = 'MAP__SET_OVERLAY_USER_POS_MARKER';
// 设置车辆marker
export const MAP__SET_OVERLAY_BUS_MARKER = 'MAP__SET_OVERLAY_BUS_MARKER';
// 设置运行中上车站marker
export const MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER = 'MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER';
// 设置运行中下车站marker
export const MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER = 'MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER';
// 设置运行中上车站label
export const MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL = 'MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL';
// 设置运行中下车站label
export const MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL = 'MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL';
// 设置定位中动效label
export const MAP__SET_OVERLAY_POSING_LABEL = 'MAP__SET_OVERLAY_POSING_LABEL';
// 设置运行中的脊线
export const MAP__SET_MAP_DATA_RUNNING_POLYLINE = 'MAP__SET_MAP_DATA_RUNNING_POLYLINE'
// 设置运行中的途经点markers
export const MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER = 'MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER';

// 4. 状态
// ====================
// 设置地图是否显示
export const MAP__SET_STATE_MAP_VISIBLE = 'MAP__SET_STATE_MAP_VISIBLE';
// 设置是否正在检索poi
export const MAP__SET_STATE_POI_SEARCHING = 'MAP__SET_STATE_POI_SEARCHING';
// 设置是否正在定位用户位置
export const MAP__SET_STATE_USER_POS_LOCATING = 'MAP__SET_STATE_USER_POS_LOCATING';
// 设置拖拽地图是否可以选择上车站
export const MAP__SET_STATE_ON_STOP_DRAGGABLE = 'MAP__SET_STATE_ON_STOP_DRAGGABLE';
// 设置拖拽地图是否可以选择下车站
export const MAP__SET_STATE_OFF_STOP_DRAGGABLE = 'MAP__SET_STATE_OFF_STOP_DRAGGABLE';
// 设置地图渲染递增值
export const MAP__SET_STATE_RENDER_FLAG = 'MAP__SET_STATE_RENDER_FLAG';
// 设置地图拖拽的最近下车站
export const MAP__SET_STATE_DRAG_NEAREST_OFF_STOP = 'MAP__SET_STATE_DRAG_NEAREST_OFF_STOP';
// 设置上车站是否在拖拽中
export const MAP__SET_STATE_DRAGGING_ON = 'MAP__SET_STATE_DRAGGING_ON';
// 设置下车站是否在拖拽中
export const MAP__SET_STATE_DRAGGING_OFF = 'MAP__SET_STATE_DRAGGING_OFF';
